import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PhotographerDashboardComponent } from '../components/photographer/dashboard/photographer-dashboard.component';
import { GetHiredComponent } from '../components/photographer/get-hired/get-hired.component';
import { PhotographerOrderListComponent } from '../components/photographer/order-list/photographer-order-list.component';
import { PhotographerComponent } from '../components/photographer/photographer.component';
import { PhotographerModule } from '../components/photographer/photographer.module';
import { ShootingListComponent } from '../components/photographer/shooting-list/shooting-list.component';
import { AccountComponent } from '../shared/components/account/account.component';
import { ManagementComponent } from '../shared/components/management/management.component';
import { SidenavTypeEnum } from '../shared/models/sidebar-group.models';
import { SharedModule } from '../shared/shared.module';
import { PhotographerOrderListAutoSortingComponent } from '../components/photographer/order-list-auto-sorting/photographer-order-list-auto-sorting.component';
import { AuthorizationGuardService } from '../shared/libs/auth/authorization-guard.service';
import { PhotographerRole } from '../models/shared/enums/photographer-role.enum';

const routes: Routes = [
  {
    path: '',
    component: PhotographerComponent,
    data: { sidenavType: SidenavTypeEnum.photographer },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: PhotographerDashboardComponent,
        data: { title: 'Dashboard | Photographer | BasicStudios', roles: [PhotographerRole.DASHBOARD_READ] },
        
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'order-list',
        component: PhotographerOrderListComponent,
        data: { title: 'Order list | Photographer | BasicStudios', roles: [PhotographerRole.ORDERLIST_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'order-list-auto-sorting',
        component: PhotographerOrderListAutoSortingComponent,
        data: { title: 'Order list Auto Sorting | Photographer | BasicStudios', roles: [PhotographerRole.ORDERLIST_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'shooting-list',
        component: ShootingListComponent,
        data: { title: 'Shooting list | Photographer | BasicStudios', roles: [PhotographerRole.SHOOTINGLIST_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'get-hired',
        component: GetHiredComponent,
        data: { title: 'Get Hired| Photographer | BasicStudios', roles: [PhotographerRole.GETHIRED_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'management',
        component: ManagementComponent,
        data: { title: 'Management | Photographer | BasicStudios', roles: [PhotographerRole.MANAGEMENT_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'account',
        component: AccountComponent,
        data: { title: 'Account | Company | BasicStudios', roles: [PhotographerRole.ACCOUNT_READ] },
        canActivate:[AuthorizationGuardService]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ]
})
export class PhotographerRouting { }
